/**
 * WOW · colour: "Colour the world" map progression (cw.*) and the stage-5 colouring coach (cc.*).
 * Lesson-level teaching text (track, tips, colour names) lives in core `colouring.ts` as {en, vi}.
 */
export const en = {
  'cw.title': 'Colour the world',
  'cw.progress': '{n}% in colour',
  'cw.hint': 'Finish a lesson to bring colour back here!',
  'cw.bloom': 'Colour is blooming!',
  'cw.allDone': 'The whole world is in colour!',
  'cw.friend': '{name} lives here',
  'cw.friends': 'Your drawings live here',

  'cc.title': 'Colour & shade',
  'cc.level': 'Colouring level {n}',
  'cc.goal': "Today's goal",
  'cc.step.palette': 'Your colours',
  'cc.step.light': 'Light & shadow',
  'cc.step.zones': 'Colour by zones',
  'cc.step.medium': 'Tool tips',
  'cc.say.palette': 'Here are the colours for {title}. Start with the biggest part!',
  'cc.say.light': 'The light comes from the top-left, like the sun. The other side gets the shadow.',
  'cc.say.zones': 'Tap a part to see how to colour it.',
  'cc.say.medium': 'Here is a tip for your colouring tools.',
  'cc.startHere': 'Start here',
  'cc.leaveWhite': 'Leave paper white',
  'cc.h.warm': 'Warm & cosy colours',
  'cc.h.cool': 'Cool & calm colours',
  'cc.h.mixed': 'Warm + cool colours',
  'cc.h.soft': 'Soft & gentle colours',
  'cc.light': 'Light',
  'cc.shadowSide': 'Shadow side',
  'cc.showShadow': 'Show the shadow side',
  'cc.lightBody': 'Colour lightly where the light hits (top-left). Press harder on the side away from the light (bottom-right).',
  'cc.phase.light': 'First a light layer',
  'cc.phase.base': 'Base colour, edges first',
  'cc.phase.shade': 'Shadow side: press harder',
  'cc.phase.highlight': 'Shine: leave paper white',
  'cc.zonesLeft': '{n} parts to try',
  'cc.zonesDone': 'You tried every part!',
  'cc.colourAll': 'Colour all',
  'cc.tapZone': 'Tap a part',
  'cc.whatTools': 'What are you colouring with?',
  'cc.next': 'Next',
  'cc.back': 'Back',
  'cc.done': 'I coloured it!',
  'cc.skip': 'Skip colouring today',
  'cc.paper': 'Colouring on paper is optional: a picture with only lines is great too.',
};

export const vi: Record<keyof typeof en, string> = {
  'cw.title': 'Tô màu thế giới',
  'cw.progress': 'Đã có màu {n}%',
  'cw.hint': 'Hoàn thành một bài để mang màu sắc trở lại đây!',
  'cw.bloom': 'Màu sắc đang nở rộ!',
  'cw.allDone': 'Cả thế giới đã rực rỡ sắc màu!',
  'cw.friend': '{name} sống ở đây',
  'cw.friends': 'Tranh của con đang sống ở đây',

  'cc.title': 'Tô màu & đổ bóng',
  'cc.level': 'Cấp tô màu {n}',
  'cc.goal': 'Mục tiêu hôm nay',
  'cc.step.palette': 'Màu của con',
  'cc.step.light': 'Sáng & tối',
  'cc.step.zones': 'Tô theo vùng',
  'cc.step.medium': 'Mẹo dụng cụ',
  'cc.say.palette': 'Đây là các màu cho bức {title}. Bắt đầu từ phần lớn nhất nhé!',
  'cc.say.light': 'Ánh sáng đến từ góc trên bên trái, giống như mặt trời. Phía bên kia sẽ có bóng.',
  'cc.say.zones': 'Chạm vào một phần để xem cách tô nhé.',
  'cc.say.medium': 'Đây là mẹo cho đồ tô màu của con.',
  'cc.startHere': 'Bắt đầu ở đây',
  'cc.leaveWhite': 'Chừa giấy trắng',
  'cc.h.warm': 'Màu ấm áp',
  'cc.h.cool': 'Màu mát dịu',
  'cc.h.mixed': 'Màu ấm + màu lạnh',
  'cc.h.soft': 'Màu nhẹ nhàng',
  'cc.light': 'Ánh sáng',
  'cc.shadowSide': 'Phía bóng',
  'cc.showShadow': 'Xem phía bóng',
  'cc.lightBody': 'Tô nhẹ tay ở chỗ ánh sáng chiếu vào (trên bên trái). Ấn mạnh hơn ở phía xa ánh sáng (dưới bên phải).',
  'cc.phase.light': 'Trước tiên: một lớp nhạt',
  'cc.phase.base': 'Màu nền, tô viền trước',
  'cc.phase.shade': 'Phía bóng: ấn mạnh hơn',
  'cc.phase.highlight': 'Điểm sáng: chừa giấy trắng',
  'cc.zonesLeft': 'Còn {n} phần để thử',
  'cc.zonesDone': 'Con đã thử hết các phần!',
  'cc.colourAll': 'Tô tất cả',
  'cc.tapZone': 'Chạm vào một phần',
  'cc.whatTools': 'Con đang tô bằng gì?',
  'cc.next': 'Tiếp',
  'cc.back': 'Quay lại',
  'cc.done': 'Con tô xong rồi!',
  'cc.skip': 'Hôm nay bỏ qua tô màu',
  'cc.paper': 'Tô màu trên giấy là tuỳ chọn: tranh chỉ có nét cũng rất tuyệt.',
};
